import {
  archivePlaybookInstance,
  completePlaybookInstance,
  searchPlaybookInstances,
  fetchAllPlaybookInstances,
  fetchPlaybookInstanceById,
  fetchPlaybookInstanceChangelog,
  markInProgressPlaybookInstance,
  showPlaybookInstanceAddEditForm,
  updatePlaybookInstance,
  resetSelectedPlaybookInstance,
  bulkArchivePlaybookInstances,
  bulkCompletePlaybookInstances,
} from '../../routines/playbookInstanceRoutines';

const initialState = {
  // instance list
  playbookInstanceList: [],
  searchedPlaybookInstancesList: [],
  playbookInstanceListLoading: false,
  playbookInstanceListSuccess: false,

  // instance by id
  selectedPlaybookInstance: null,
  selectedPlaybookInstanceLoading: false,
  selectedPlaybookInstanceSuccess: false,
  playbookInstanceUpdating: false,
  searchedPlaybooksInstancesLoading: false,

  // actions
  playbookInstanceCompleting: false,
  playbookInstanceInProgressMarking: false,
  playbookInstanceArchiving: false,

  paginationData: {
    totalItems: 0,
  },
  massUpdate: {
    loading: false,
  },

  // other
  showAddEditForm: false,
};

const playbookInstanceReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch playbookInstances
    case showPlaybookInstanceAddEditForm.TRIGGER:
      return {
        ...state,
        showAddEditForm: action.payload.showForm,
      };

    case fetchAllPlaybookInstances.TRIGGER:
      return {
        ...state,
        playbookInstanceListSuccess: false,
        playbookInstanceListLoading: true,
      };
    case fetchAllPlaybookInstances.SUCCESS: {
      const { response, currentPayload } = action.payload;
      return {
        ...state,
        playbookInstanceListLoading: false,
        playbookInstanceListSuccess: true,
        playbookInstanceList: response?.data.playbookInstances || [],
        paginationData: {
          page: response?.data.page,
          organizationCount:
            response?.data?.count?.entityCount?.organizationCount,
          accountCount: response?.data?.count?.entityCount?.accCount,
          overDueCount: response?.data?.count?.overDueCount,
          allCount: response?.data?.count?.total,
          totalItems: response?.data.count?.paginationTotal,
        },
        currentPayload,
      };
    }
    case fetchAllPlaybookInstances.FAILURE:
      return {
        ...state,
        playbookInstanceListLoading: false,
        playbookInstanceListSuccess: false,
      };

    // fetch playbookInstances by ID
    case fetchPlaybookInstanceById.TRIGGER:
      return {
        ...state,
        selectedPlaybookInstanceLoading: true,
      };
    case fetchPlaybookInstanceById.SUCCESS:
      return {
        ...state,
        selectedPlaybookInstanceLoading: false,
        selectedPlaybookInstanceSuccess: true,
        selectedPlaybookInstance: action.payload?.data || null,
      };
    case fetchPlaybookInstanceById.FAILURE:
      return {
        ...state,
        selectedPlaybookInstanceLoading: false,
        selectedPlaybookInstanceSuccess: false,
      };

    // reset selected playbook instance
    case resetSelectedPlaybookInstance.TRIGGER:
      return {
        ...state,
        selectedPlaybookInstance: null,
        selectedPlaybookInstanceLoading: false,
        selectedPlaybookInstanceSuccess: false,
      };

    // fetch changelog by playbookInstanceId
    case fetchPlaybookInstanceChangelog.TRIGGER:
      return {
        ...state,
        selectedPlaybookInstance: {
          ...state.selectedPlaybookInstance,
          changeLogLoading: true,
        },
      };
    case fetchPlaybookInstanceChangelog.SUCCESS:
      return {
        ...state,
        selectedPlaybookInstance: {
          ...state.selectedPlaybookInstance,
          changeLogLoading: false,
          changeLogSuccess: true,
          changeLog: action.payload?.data || [],
        },
      };
    case fetchPlaybookInstanceChangelog.FAILURE:
      return {
        ...state,
        selectedPlaybookInstance: {
          ...state.selectedPlaybookInstance,
          changeLogLoading: false,
          changeLogSuccess: false,
        },
      };

    // complete playbookInstances
    case completePlaybookInstance.TRIGGER:
      return {
        ...state,
        playbookInstanceCompleting: true,
      };
    case completePlaybookInstance.SUCCESS:
    case completePlaybookInstance.FAILURE:
      return {
        ...state,
        playbookInstanceCompleting: false,
      };

    // bulk complete playbookInstances
    case bulkArchivePlaybookInstances.TRIGGER:
    case bulkCompletePlaybookInstances.TRIGGER:
      return {
        ...state,
        massUpdate: {
          loading: true,
        },
      };
    case bulkArchivePlaybookInstances.SUCCESS:
    case bulkArchivePlaybookInstances.FAILURE:
    case bulkCompletePlaybookInstances.SUCCESS:
    case bulkCompletePlaybookInstances.FAILURE:
      return {
        ...state,
        massUpdate: {
          loading: false,
        },
      };

    // marking as in progress playbookInstances
    case markInProgressPlaybookInstance.TRIGGER:
      return {
        ...state,
        playbookInstanceInProgressMarking: true,
      };
    case markInProgressPlaybookInstance.SUCCESS:
    case markInProgressPlaybookInstance.FAILURE:
      return {
        ...state,
        playbookInstanceInProgressMarking: false,
      };

    // archive playbookInstance
    case archivePlaybookInstance.TRIGGER:
      return {
        ...state,
        playbookInstanceArchiving: true,
      };
    case archivePlaybookInstance.SUCCESS:
    case archivePlaybookInstance.FAILURE:
      return {
        ...state,
        playbookInstanceArchiving: false,
      };

    // update playbookInstances
    case updatePlaybookInstance.TRIGGER:
      return {
        ...state,
        playbookInstanceUpdating: true,
      };
    case updatePlaybookInstance.SUCCESS:
      return {
        ...state,
        playbookInstanceUpdating: false,
      };
    case updatePlaybookInstance.FAILURE:
      return {
        ...state,
        playbookInstanceUpdating: false,
      };

    case searchPlaybookInstances.TRIGGER:
      return {
        ...state,
        searchedPlaybooksInstancesLoading: true,
      };
    case searchPlaybookInstances.SUCCESS:
      return {
        ...state,
        searchedPlaybooksInstancesLoading: false,
        searchedPlaybookInstancesList: action.payload?.data || [],
      };
    case searchPlaybookInstances.FAILURE:
      return {
        ...state,
        searchedPlaybooksInstancesLoading: false,
      };

    default:
      return state;
  }
};

export default playbookInstanceReducer;
